import { initializeApp, getApps } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import {
  getAuth,
  initializeAuth,
  browserLocalPersistence,
} from "firebase/auth";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyAnjIPfBfQZQe_I44J1AMZYTSA-BKMsmGE",
  authDomain: "click4marry-871b0.firebaseapp.com",
  projectId: "click4marry-871b0",
  storageBucket: "click4marry-871b0.firebasestorage.app",
  messagingSenderId: "141482297385",
  appId: "1:141482297385:web:c7cfaedfc75117c1407438",
  databaseURL:
    "https://click4marry-871b0-default-rtdb.asia-southeast1.firebasedatabase.app",
};
// Initialize only if not already created
const chatApp =
  getApps().find((app) => app.name === "chatApp") ||
  initializeApp(firebaseConfig, "chatApp");

// ✅ Properly initialize Auth for secondary app
let auth;
try {
  auth = initializeAuth(chatApp, {
    persistence: browserLocalPersistence,
  });
} catch (e) {
  // if already initialized, just get it
  auth = getAuth(chatApp);
}

export const db = getFirestore(chatApp);
export const rtdb = getDatabase(chatApp); // 👈 THIS

export { auth };
